import * as React from 'react';
import { ThemeConsumer } from '../../atoms/theme';
import { Card } from 'ui';

export class CommunityCard extends React.Component {
  render() {
    const { community } = this.props;

    return (
      <ThemeConsumer>
        {(theme) => (
          <div>
            <Card shrinked>
              <div className={`card ${this.props.className || null}`}>
                <div className="card__image" onClick={this.props.onClick}>
                  <img src={community.cover_photo?.url} alt="Community cover" />
                </div>

                <div className="card__body">
                  <h5 className="card__title" onClick={this.props.onClick} style={{ color: theme.color.brand }}>
                    {community.name}
                  </h5>
                </div>
              </div>
            </Card>
          </div>
        )}
      </ThemeConsumer>
    );
  }
}
